module.exports = __webpack_public_path__ + "static/media/wallet-active.034d2191.svg";